import { render } from "./Questionario.vue?vue&type=template&id=5a040f4d"
import script from "./Questionario.vue?vue&type=script&lang=js"
export * from "./Questionario.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__